module.exports = __webpack_public_path__ + "static/media/phone-tablet.33a1dbfc.jpg";